export default __webpack_public_path__ + "static/media/settingIcon.1abe4ba9.svg";